import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/bank_accounts',
  component: Management,
  redirect: '/bank_accounts/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/bank_accounts/List'),
      meta: {
        auth: Auth.listBankAccounts
      },
      redirect: 'list/all',
      children: [
        {
          path: 'all',
          component: () => import('@/views/bank_accounts/ListTable'),
          meta: {
            auth: Auth.listBankAccounts
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/bank_accounts/New'),
      meta: {
        auth: Auth.createBankAccount
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/bank_accounts/Edit'),
      meta: {
        auth: Auth.updateBankAccount
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/bank_accounts/DetailLayout'),
      meta: {
        auth: Auth.showBankAccount
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/bank_accounts/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showBankAccount
          }
        }
      ]
    }
  ]
}
